function o() {
  return window.adobeIMS ? window.adobeIMS.getAccessToken().token : "";
}
async function n() {
  return window.adobeIMS ? window.adobeIMS.getProfile().then((e) => e.userId) : Promise.resolve("");
}
export {
  o as getAccessToken,
  n as getUserId
};
//# sourceMappingURL=IMSLib.js.map
